// src/ui/theme/tokenCatalog.js
// Metadata de UX de cada token para el editor de estilos: que es, que cambia y
// DONDE se ve en la plataforma. Ayuda al disenador a ser consciente del efecto
// de cada opcion. Fuente unica; el editor lo consume para hints, tooltips,
// agrupacion y el resaltado de la vista previa.
//
// - label:     nombre legible
// - hint:      que cambia (frase corta)
// - appliesTo: vistas/elementos reales donde se aplica
// - group:     subgrupo dentro de la seccion Colores (brand|text|surfaces|state)
// - zones:     zonas de la vista previa que resalta este token
export const TOKEN_CATALOG = {
  "color.primary": {
    label: "Primario",
    hint: "Color de marca: botones, acentos y elemento activo del menu.",
    appliesTo: [
      "Botones principales (Nuevo itinerario, Anadir a itinerario)",
      "Item activo del menu lateral",
      "Tags y acentos de las pantallas",
    ],
    group: "brand",
    zones: ["btn", "btnGhost"],
  },
  "color.primaryDark": {
    label: "Primario oscuro",
    hint: "Verde oscuro para estados hover y textos sobre fondo claro.",
    appliesTo: ["Hover de botones", "Texto de carga en cards de escena"],
    group: "brand",
    zones: ["btn"],
  },
  "color.surface": {
    label: "Superficie / card",
    hint: "Fondo de tarjetas, paneles y modales.",
    appliesTo: [
      "Cards de escena (catalogo)",
      "Paneles y modales",
      "Boton secundario",
    ],
    group: "surfaces",
    zones: ["card", "btnGhost"],
  },
  "color.canvas": {
    label: "Fondo de pagina",
    hint: "Fondo general detras del contenido.",
    appliesTo: ["Fondo de todas las pantallas del profesor"],
    group: "surfaces",
    zones: ["canvas"],
  },
  "color.border": {
    label: "Bordes",
    hint: "Lineas, separadores y bordes de tarjetas e inputs.",
    appliesTo: ["Borde de cards", "Separadores", "Bordes de inputs"],
    group: "surfaces",
    zones: ["card", "thumb", "btnGhost"],
  },
  "color.text": {
    label: "Texto",
    hint: "Color del texto principal y titulos.",
    appliesTo: ["Titulos de cards y pantallas", "Texto principal"],
    group: "text",
    zones: ["title"],
  },
  "color.textMuted": {
    label: "Texto atenuado",
    hint: "Texto secundario: subtitulos y descripciones.",
    appliesTo: ["Subtitulos", "Descripciones", '"Creado por"'],
    group: "text",
    zones: ["sub", "muted"],
  },
  "color.tintSoft": {
    label: "Tinte suave",
    hint: "Fondo verde muy suave para zonas destacadas.",
    appliesTo: ["Fondos de seccion destacada", "Estados seleccionados suaves"],
    group: "surfaces",
    zones: ["thumb"],
  },
  "color.tintHover": {
    label: "Tinte hover",
    hint: "Fondo verde suave de miniaturas y hover de items.",
    appliesTo: [
      "Fondo de miniatura de las cards",
      "Hover de elementos de lista",
    ],
    group: "surfaces",
    zones: ["thumb"],
  },
  "color.danger": {
    label: "Peligro / error",
    hint: "Errores y acciones destructivas.",
    appliesTo: ["Mensajes de error", "Boton de borrar"],
    group: "state",
    zones: ["error"],
  },
  "color.sidebarBg": {
    label: "Fondo del menu",
    hint: "Color de fondo de la barra lateral.",
    appliesTo: ["Menu lateral (sidebar)"],
    group: "sidebar",
    zones: [],
  },
  "sidebar.itemText": {
    label: "Texto de items",
    hint: "Color del texto de las opciones del menu.",
    appliesTo: ["Opciones del menu lateral (estado normal)"],
    zones: [],
  },
  "sidebar.itemActiveBg": {
    label: "Fondo item activo",
    hint: "Fondo de la opcion seleccionada del menu.",
    appliesTo: ["Opcion activa del menu lateral"],
    zones: [],
  },
  "sidebar.itemActiveText": {
    label: "Texto item activo",
    hint: "Color del texto de la opcion seleccionada y en hover.",
    appliesTo: ["Opcion activa / hover del menu lateral"],
    zones: [],
  },
  "sidebar.itemHoverBg": {
    label: "Fondo hover",
    hint: "Fondo de la opcion al pasar el raton.",
    appliesTo: ["Opciones del menu lateral (hover)"],
    zones: [],
  },
  "sidebar.itemRadius": {
    label: "Radio de items",
    hint: "Redondez de las opciones del menu.",
    appliesTo: ["Opciones del menu lateral"],
    zones: [],
  },
  "font.display": {
    label: "Fuente de titulos",
    hint: "Tipografia de los titulos.",
    appliesTo: ["Titulos de pantallas y cards"],
    zones: ["title"],
  },
  "font.body": {
    label: "Fuente de texto",
    hint: "Tipografia del texto general y botones.",
    appliesTo: ["Texto general", "Botones", "Descripciones"],
    zones: ["muted"],
  },
  "radius.control": {
    label: "Radio de controles",
    hint: "Redondez de botones, inputs y miniaturas.",
    appliesTo: ["Botones", "Inputs", "Miniaturas"],
    zones: ["btn", "btnGhost", "thumb"],
  },
  "radius.card": {
    label: "Radio de cards",
    hint: "Redondez de tarjetas y paneles.",
    appliesTo: ["Cards de escena", "Paneles"],
    zones: ["card"],
  },
};

// Subgrupos de la seccion Colores, en orden de aparicion.
export const COLOR_GROUPS = [
  { key: "brand", label: "Marca" },
  { key: "text", label: "Texto" },
  { key: "surfaces", label: "Superficies y fondos" },
  { key: "state", label: "Estados" },
];

export default TOKEN_CATALOG;
